import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { ProjectsComponent } from './projects.component';
import {
  NbButtonGroupModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbTooltipModule,
  NbToggleModule,
  NbBadgeModule,
  NbMenuModule,
  NbOptionModule,
  NbSelectModule,
} from '@nebular/theme';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateProjectFormComponent } from './components/create-project-form/create-project-form.component';
import { ProjectCardItemComponent } from './components/project-card-item/project-card-item.component';
import { AccountSelectionDropdownModule } from 'src/app/components/account-selection-dropdown/account-selection-dropdown.module';
import { ProjectTypeSupportedIntentsModule } from 'src/app/components/project-type-supported-intents/project-type-supported-intents.module';

@NgModule({
  declarations: [
    ProjectsComponent,
    CreateProjectFormComponent,
    ProjectCardItemComponent,
  ],
  imports: [
    CommonModule,
    ProjectsRoutingModule,
    ComponentsModule,
    NbCardModule,
    NbIconModule,
    ReactiveFormsModule,
    NbButtonModule,
    NbTooltipModule,
    NbSpinnerModule,
    NbButtonGroupModule,
    NbCheckboxModule,
    NbFormFieldModule,
    NbInputModule,
    NbToggleModule,
    AccountSelectionDropdownModule,
    ProjectTypeSupportedIntentsModule,
    NbBadgeModule,
    NbMenuModule,
    NbOptionModule,
    NbSelectModule,
  ],
  exports: [CreateProjectFormComponent],
})
export class ProjectsModule {}
